var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.374 7.9813C11.7773 7.46262 11.9974 6.82498 12 6.16797C12 4.51397 10.654 3.16797 9 3.16797H4V13.168H9.33333C10.9873 13.168 12.3333 11.822 12.3333 10.168C12.3324 9.7571 12.2468 9.35084 12.0817 8.97459C11.9166 8.59834 11.6757 8.2602 11.374 7.9813ZM9 5.16797C9.55133 5.16797 10 5.61664 10 6.16797C10 6.7193 9.55133 7.16797 9 7.16797H6V5.16797H9ZM9.33333 11.168H6V9.16797H9.33333C9.88467 9.16797 10.3333 9.61664 10.3333 10.168C10.3333 10.7193 9.88467 11.168 9.33333 11.168Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxBold);
export default __webpack_public_path__ + "static/media/bx-bold.eaa2c795723e376e735ec22d3a4cf826.svg";
export { ForwardRef as ReactComponent };